const getOrderParams = ( selected ) => {
	let orderby, order;
	switch ( selected ) {
	case 'default':
		orderby = 'date';
		order = 'DESC';
		break;
	case 'rating_asc':
		orderby = 'rating';
		order = 'ASC';
		break;
	case 'rating_desc':
		orderby = 'rating';
		order = 'DESC';
		break;
	default:
		orderby = 'date';
		order = 'DESC';
		break;
	}

	return { orderby, order };
};

export { getOrderParams };
